import React from 'react';
import './Prompt.css';

const OverView = ({ purpose, role, goal }) => {
  const renderSection = (title, content) => {
    if (!content) return null;
    
    return (
      <div className="detail-item">
        <div className="overview-heading">{title}:</div>
        <div className="overview-content">{content}</div>
      </div>
    );
  };

  return (
    <div className="details-container">
      {renderSection('Purpose', purpose)}
      {renderSection('Role', role)} 
      {renderSection('Goal', goal)}
    </div>
  );
};

export default OverView;